"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.createTheme = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _styles = require("@material-ui/core/styles");
var _utils = require("./styles/utils");
var _constants = require("./utils/constants");
var _tailwind = require("./tailwind.config");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getOverridesForDarkMode = function getOverridesForDarkMode(styles) {
  return {
    MuiDialog: {
      paper: {
        backgroundColor: styles.get(_tailwind.theme.extend.backgroundColor.card)
      }
    },
    MuiPopover: {
      paper: {
        backgroundColor: styles.get(_tailwind.theme.extend.backgroundColor.card)
      }
    },
    MuiPaper: {
      root: {
        backgroundColor: styles.get(_tailwind.theme.extend.backgroundColor.card)
      }
    },
    MuiIconButton: {
      root: {
        color: styles.get(_tailwind.theme.colors.gray.dark)
      }
    },
    MuiBackdrop: {
      root: {
        backgroundColor: 'rgba(0, 0,0, 0.7)'
      }
    }
  };
};
var createTheme = exports.createTheme = function createTheme() {
  var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.themeMode.LIGHT;
  var styles = (0, _utils.getComputedStyles)();
  var overridesForDarkMode = getOverridesForDarkMode(styles);
  return (0, _styles.createTheme)({
    palette: {
      type: mode,
      primary: {
        main: styles.get(_tailwind.theme.colors.primary, '#136aee')
      },
      secondary: {
        main: styles.get(_tailwind.theme.extend.backgroundColor.secondary, '#1e1e1e')
      },
      error: {
        main: styles.get(_tailwind.theme.colors.red)
      },
      warning: {
        main: styles.get(_tailwind.theme.colors.orange)
      },
      yellow: {
        main: styles.get(_tailwind.theme.colors.yellow)
      },
      app: {
        main: styles.get(_tailwind.theme.extend.backgroundColor.app),
        divider: styles.get(_tailwind.theme.extend.backgroundColor.divider)
      },
      card: {
        main: styles.get(_tailwind.theme.extend.backgroundColor.card)
      },
      text: {
        primary: styles.get(_tailwind.theme.extend.textColor.dark),
        'primary-active': styles.get(_tailwind.theme.extend.textColor['primary-active']),
        secondary: styles.get(_tailwind.theme.extend.textColor.medium),
        disabled: styles.get(_tailwind.theme.extend.textColor.light)
      }
    },
    shadows: ['none', _tailwind.theme.boxShadow['md'], _tailwind.theme.boxShadow['default'], _tailwind.theme.boxShadow['lg'], _tailwind.theme.boxShadow['xl'], _tailwind.theme.boxShadow['2xl'], _tailwind.theme.extend.boxShadow['hover']],
    breakpoints: {
      // Keep consistent with Tailwind
      values: {
        xs: 475,
        sm: 640,
        md: 768,
        lg: 1024,
        xl: 1280
      }
    },
    overrides: _objectSpread({
      MuiDialogActions: {
        root: {
          padding: '8px 24px 16px'
        }
      },
      MuiFab: {
        root: {
          backgroundColor: styles.get(_tailwind.theme.extend.backgroundColor.app),
          color: styles.get(_tailwind.theme.colors.gray.medium),
          '&:hover': {
            backgroundColor: styles.get(_tailwind.theme.extend.backgroundColor.app),
            color: styles.get(_tailwind.theme.colors.gray.dark)
          }
        }
      }
    }, mode === _constants.themeMode.DARK ? overridesForDarkMode : {})
  });
};
var _default = exports["default"] = createTheme;
//# sourceMappingURL=material-ui.theme.js.map